import { setCookie } from "./cookie-helper"

export const getLogo = async (domain, hash) => {
	const response = await fetch(`${process.env.REACT_APP_OUTBACK_API_URL}/${process.env.REACT_APP_STAGE}/logo?domainName=${domain}`, {
		method: "GET",
		headers: { "Content-Type": "application/json", "OutbackHash": hash }
	})
	const data = await response.json()
	setCookie("Logo", data.logo, 86400)
}